import { gql } from "apollo-angular";
import { LINK_FIELDS } from "./link";
import { NAVLINKS } from "./menu-link";

export const HEADER_FIELDS = gql`
fragment HEADER_FIELDS on WebsiteHeader {
    sys { id }
    logo {
        url
        description
    }
    logoLink
    logoImageUrl
    contactUsPhoneNumber
    phoneNumberLink
    contactUsChat
    contactUsLinkTitle
    contactUsLink {
      ... on OptimizedCombo {
        url
      }
    }
    buttonLink1 {
        ... LINK_FIELDS
    }
    buttonLink2 {
      ... LINK_FIELDS
    }
    navigationCollection (limit: 10){  
      items{
        ... NAVLINKS
      }
    }
    mostCommonSearch
    search
    stdLoginTxt
    stdLoginLink
    hidePartnerLogo
    isPzd
}
${LINK_FIELDS}
${NAVLINKS}`;
